<template>
    <div>
        <edit-base-dues-modal
            v-model="show_dues_dialog"
            :memberId="this.member.id"
            :modelProp="dueSelected"
            :valuelists="valuelists"
            @successful-save="$refs.membersdues_list.refreshList()"

        />
        <!-- Top part -->
        <div class="tw-flex tw-flex-row tw-gap-4 tw-p-1">
            <!-- First column -->
            <div class="tw-flex tw-flex-col tw-w-1/12">
                <v-btn
                    text
                    @click="addDue"
                    class="main-btn"
                >
                    Add New Entry
                </v-btn>
                <div v-for="report in reports">
                    <v-btn @click="navigateToDuesInvoiceReport" class="main-btn mt-3 tw-w-full">
                        {{ report.label }}
                    </v-btn>
                </div>
                <div class="tw-mt-4">
                    Print statement:
                    <div class="tw-flex tw-items-center">
                        <input
                            type="radio"
                            id="print-yes"
                            name="print-option"
                            class="tw-mr-2"
                        />
                        <label for="print-yes" class="tw-mr-4">Yes</label>
                        <input
                            type="radio"
                            id="print-no"
                            name="print-option"
                            class="tw-mr-2"
                        />
                        <label for="print-no">No</label>
                    </div>
                </div>

            </div>
            <!-- Second column -->
            <div class="tw-flex tw-flex-col tw-w-6/12">
                <internal-table-section :hasButton="false">
                    <div class="tw-flex tw-flex-row tw-gap-4 tw-p-1">
                        <!-- First column -->
                        <div class="tw-flex tw-flex-col tw-w-1/3">
                            <v-text-field
                                v-model="member.date_ia_membership"
                                append-icon="mdi-calendar"
                                color="primary"
                                label="IA667 Membership Date"
                                readonly
                            />
                            <v-text-field
                                v-model="member.date_reinstatement"
                                v-show="!!member.date_reinstatement && (member.date_reinstatement !== member.date_ia_membership)"
                                append-icon="mdi-calendar"
                                color="primary"
                                label="Date of Earliest IA Membership"
                                readonly
                            />
                        </div>
                        <div class="tw-flex tw-flex-col tw-w-1/3">
                            <v-text-field
                                v-model="member.date_payup_notice"
                                append-icon="mdi-calendar"
                                color="primary"
                                label="Payup Notice Date"
                                readonly
                            />
                        </div>
                        <!-- Second column -->
                        <div class="tw-flex tw-flex-col tw-w-1/3">
                            <v-text-field
                                v-model="member.date_termination"
                                append-icon="mdi-calendar"
                                color="primary"
                                label="Termination Date"
                                readonly
                            />
                            <v-text-field
                                v-model="member.internal_code"
                                color="primary"
                                label="Internal Code"
                                readonly
                            />
                        </div>
                    </div>
                </internal-table-section>
            </div>
            <!-- Third column -->
            <div class="tw-flex tw-flex-col tw-w-3/12">
                <v-textarea
                    label="Notes"
                    outlined
                    readonly
                    auto-grow
                    compact
                    :value="member.base_dues_note"
                >
                </v-textarea>
            </div>
            <div class="tw-flex tw-flex-col tw-w-2/12">
                <v-btn
                    text
                    @click="printPayupNotice"
                    class="main-btn"
                    :loading="printPayupNoticeLoading"
                >
                    Print Payup Notice
                </v-btn>
                <v-btn
                    text
                    @click="printNoticeOfExplulsion"
                    class="main-btn tw-mt-4"
                >
                    Print Expulsion Notice
                </v-btn>
            </div>
        </div>

        <!-- Bottom part -->
        <div class="pt-6">
            <smart-table
                id="membersdues_list"
                class="row-pointer"
                endpoint="membersdues.list"
                :headers="tableHeaders"
                @fetch-complete="summarizeData"
                :multi-sort="true"
                :items-per-page="20"
                :footer-props="{
                'items-per-page-options': [5, 10, 20, 30]
                }"
                flat
                @click:row="editDue"
                ref="membersdues_list"
            >
                <template v-slot:item.current_year="{ isMobile, item, header, value, index}">
                    {{ displayYear(item) }}
                </template>
                <template v-slot:item.check_number="{ isMobile, item, header, value, index}">
                    {{ value }}
                </template>
                <template v-slot:item.action="{ isMobile, item, header, value, index}">
                    <v-icon
                        @click.stop="deleteDue(item)">
                    mdi-delete
                    </v-icon>
                </template>
            </smart-table>

            <div class="tw-flex tw-w-1/2">
                <div class="tw-border tw-border-black tw-p-4 tw-mt-4 tw-flex tw-flex-row tw-flex-wrap">
                    <div class="tw-flex tw-w-3/12 tw-mt-2">
                        <v-text-field :value="balance_previous" label="Balance Previous" readonly></v-text-field>
                    </div>

                    <div class="tw-flex tw-items-center mx-1">
                        <span>+</span>
                    </div>
                    <div class="tw-flex tw-w-3/12 tw-mt-2">
                        <v-text-field :value="balance_current" label="Balance Statement" readonly></v-text-field>
                    </div>

                    <div class="tw-flex tw-items-center mx-1">
                        <span>=</span>
                    </div>
                    <div class="tw-flex tw-w-3/12 tw-mt-2">
                        <v-text-field :value="balance_previous + balance_current" label="Balance Due" readonly></v-text-field>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import InternalHeader from "@/Generic/InternalHeader";
import InternalTableSection from "@/Generic/InternalTableSection";
import SmartTable from "@/Generic/SmartTable.vue";
import DatePicker from "@/Generic/DatePicker";
import EditBaseDuesModal from "@/Pages/InternalPages/Members/Modals/EditBaseDuesModal";

export default {
    name: "MembersShowBaseDues",
    components: {
        SmartTable,
        InternalHeader,
        InternalTableSection,
        DatePicker,
        EditBaseDuesModal,
    },
    props: {
        'input': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'constants': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'valuelists': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        }
    },
    data() {
        return {
            show_dues_dialog: false,
            member: this.input,
            dueSelected: this.item,
            constant: this.constants,
            valuelist: this.valuelists,
            is_loading: true,
            production_names: null,
            memberDues: [],
            balance_previous: null,
            balance_current: null,
            printPayupNoticeLoading: false,

        }
    },
    computed: {
        tableHeaders() {
            return [
                { text: "Due Date",        value: "date_due" ,          sortable: true,     filterable: true },
                { text: "Current Year",    value: "current_year" ,      sortable: false,    filterable: false },
                { text: "Payment Date",    value: "date_payment" ,      sortable: false,    filterable: false},
                { text: "Item Paid",       value: "paid_item" ,         sortable: false,    filterable: false},
                { text: "Payment Mode",    value: "type_payment" ,      sortable: false,    filterable: false},
                { text: "Cheque or Bank",  value: "check_number" ,      sortable: false,    filterable: false},
                { text: "Deposit Date",    value: "date_deposit" ,      sortable: false,    filterable: false},
                { text: "Due",             value: "amount_due" ,        sortable: false,    filterable: false},
                { text: "Payment",         value: "amount_payment" ,    sortable: false,    filterable: false},
                { text: "",                value: "action" },
                { text: 'User',            value: 'user_id',            sortable: true,     filterable: true, align: ` d-none`,     search: this.member.id },

            ];
        },
        reports() {
            return [
                {label:'Export to PDF',         route:'reports.duesinvoice'},
            ]
        },
    },
    mounted() {
        this.fetchTotals()
    },
    methods: {
        getCurrentYear() {
            const currentDate = new Date();
            return currentDate.getFullYear();
        },
        summarizeData() {
            let recordset = this.$refs.membersdues_list.items_local
            let new_memberDues = []

            recordset.forEach((record) => {
                let dues_amount = Number(record.amount_due) - Number(record.amount_payment)
                new_memberDues.push({ ...record, dues_amount })
            });

            this.memberDues = new_memberDues;
        },
        editDue(item) {
            this.dueSelected = item
            this.show_dues_dialog = true
        },
        addDue() {
            this.dueSelected = null
            this.show_dues_dialog = true
        },
        printPayupNotice() {
            if ((this.balance_previous + this.balance_current) === 0){
                this.$root.snackbar.error('Member has a zero balance due. Cannot print Payup notice')
            }else{
                let url = route('membersnotice', [this.member.id, 'payup']) ;
                window.open(url, "_blank").focus();
            }
        },
        printNoticeOfExplulsion() {
            let url = route('membersnotice', [this.member.id, 'expulsion']);
            window.open(url, "_blank").focus();
        },
        showDuesItem(){
           //
        },
        async deleteDue(item) {
            if (await this.$root.confirm.open(`Delete Base due?`, `You are about to delete this Base due`)) {
                let method = 'delete'
                let url = route('membersdues.destroy', item.id)
                let payload = item

                axios({
                    method: method,
                    url: url,
                    data: payload,
                    onUploadProgress: (evt) => {
                        this.archiveLoading = !this.archiveLoading
                    },
                    onDownloadProgress: (evt) => {
                        this.archiveLoading = !this.archiveLoading
                    },
                })
                    .then(response => {
                        if (response.data.success) {
                            this.$root.is_dirty = false
                            this.$root.snackbar.success('Base due has been deleted')
                            this.dialog = false
                            this.$root.is_dirty = false
                            this.archiveLoading = false
                            this.$refs.membersdues_list.refreshList()
                        } else {
                            throw (response.data.error)
                        }
                    })
                    .catch((error) => {
                        this.$root.snackbar.error(error.response.data.message)
                        this.archiveLoading = false
                    })
            }
        },
        displayYear(member_due_record) {
            const date_to_use = member_due_record.date_due || member_due_record.date_payment
            if (!date_to_use) return ''

            const [year, month, day] = date_to_use.split("-").map(Number);
            const timezone_adjusted = new Date(year, month - 1, day); // Month is zero-based

            return new Date(timezone_adjusted).getFullYear();
        },


        fetchTotals() {
            axios.post(route('memberdues-usertotals', this.member?.id).url())
                .then((response) => {
                    this.balance_current = response?.data?.current?.sum_balance ?? 0
                    this.balance_previous = response?.data?.previous?.sum_balance ?? 0
                })
                .catch(error => {
                    this.$root.snackbar.error(error)
                })
        },
        navigateToDuesInvoiceReport() {
            this.$inertia.visit(route('reports.duesinvoice'), { data: { user_id: this.member.id } })
        }
    },
    watch: {
        input(newInput, oldInput) {
            this.member = newInput
            this.fetchTotals()
        },
    }
}
</script>
